import React, {
  HTMLProps, MouseEvent, ReactNode, forwardRef
} from 'react';
import clsx from 'clsx';

import {
  ArrowDownIcon, CloseCircleIcon
} from 'src/shared/icons';

import * as Style from './ClearableSelectButton.styles';

interface ClearableSelectButtonProps extends HTMLProps<HTMLDivElement> {
  onClear: () => void;
  onButtonClick: () => void;
  isOpen: boolean;
  isSelectedValue: boolean;
  title: string;
  leftIcon?: ReactNode;
  withIndicator?: boolean;
}

export const ClearableSelectButton = forwardRef<
HTMLDivElement,
ClearableSelectButtonProps
>(
  (
    {
      onClear,
      onButtonClick,
      isOpen,
      isSelectedValue,
      title,
      leftIcon,
      withIndicator = true,
      ...props
    },
    ref,
  ) => {
    const handleClear = (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      onClear();
    };

    return (
      <Style.SelectContainer
        onClick={onButtonClick}
        $isOpen={isOpen}
        $withValue={isSelectedValue}
        tabIndex={0}
        role="button"
        ref={ref}
        {...props}
      >
        <Style.TitleContainer>
          {leftIcon}

          {title}
        </Style.TitleContainer>

        {isSelectedValue && (
          <button
            onClick={handleClear}
            type="button"
          >
            <CloseCircleIcon className="text-button-blue" />
          </button>
        )}

        {withIndicator && (
          <ArrowDownIcon
            className={clsx({
              'rotate-180': isOpen,
              'text-accent80': isSelectedValue,
              'text-dark-gray': !isSelectedValue,
            })}
          />
        )}
      </Style.SelectContainer>
    );
  },
);
